import { render, staticRenderFns } from "./badgesCellRenderer.vue?vue&type=template&id=365bece1&scoped=true"
import script from "./badgesCellRenderer.ts?vue&type=script&lang=ts&external"
export * from "./badgesCellRenderer.ts?vue&type=script&lang=ts&external"
import style0 from "./badgesCellRenderer.vue?vue&type=style&index=0&id=365bece1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365bece1",
  null
  
)

export default component.exports